/**
 * Utility functions for address data handling.
 * Extracted as a separate module to avoid circular dependencies between
 * address.ts, address-mutations.ts, and plan.ts.
 */

export function fixPostalCode(postalCode?: string, country?: string | null) {
  if (!postalCode || !country) return postalCode;
  const postalCodeNoSpaces = postalCode.replace(/\s/g, '');
  const isFrenchPostalCode = /^\d{5}$/.test(postalCodeNoSpaces);
  return country === 'CA' && !isFrenchPostalCode
    ? postalCodeNoSpaces
        .split('')
        .map((char, index) => {
          if ((index === 2 || index === 4) && char === '0') return 'O';
          if ((index === 1 || index === 3 || index === 5) && char.toLocaleLowerCase() === 'o') return '0';
          return char;
        })
        .join('')
    : postalCodeNoSpaces;
}

export function getAddressPayload<T extends { postalCode?: string; country?: string | null }>(
  payload?: T | null,
  invitedBy?: string | null,
) {
  if (!payload) {
    return payload;
  }
  return {
    ...payload,
    postalCode: fixPostalCode(payload.postalCode, payload.country),
    inviteCode: invitedBy,
  };
}
